import { UiBlockType } from '../ReactFlow/types';

const USER_FIELD_NAMES = [
  'id',
  'role',
  'email',
  'registered',
  'phoneNumber',
  'phoneNumberVerified',
  'firstName',
  'middleName',
  'lastName',
  'prefix',
  'suffix',
  'sex',
  'dateOfBirth',
  'npi',
  'kind',
  'internal',
  'passbookImageUrl',
  'paypassImageUrl',
  'previsitImageUrl',
  'virtualVisitUrl',
  'deleted',
  'deletedTimestamp',
  'loginLastAttemptedTimestamp',
  'loginFailedCount',
  'loginLocked',
  'careProviderId',
  'enforceInternalIP',
];

const DATA_ANY_ARRAY_FIELD_NAMES = ['data', 'data[]'];

/**
 * Make sure none of these have spaces. Any space will break autocomplete in some cases.
 * Specifically, When using the non braces autocomplete, the space will break typing things like `return patient.`.
 */
export const NODE_FIELD_NAMES_BY_NODE_TYPE: Partial<Record<UiBlockType, string[]>> = {
  [UiBlockType.Start]: [
    'organizationId',
    'practiceId',
    'entityType',
    'entityId',
    'entity',
    'startData',
  ],
  [UiBlockType.GetPatient]: USER_FIELD_NAMES,
  [UiBlockType.Fhir]: DATA_ANY_ARRAY_FIELD_NAMES,
};
